import React from 'react';
import { RED, BLACK } from '../components/Layout';

interface StaticPageProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

export const StaticPage: React.FC<StaticPageProps> = ({ title, subtitle, children }) => (
  <div style={{ padding: '60px 40px', maxWidth: 800, margin: '0 auto' }}>
    <h1 style={{ fontWeight: 900, fontStyle: 'italic', fontSize: 'clamp(2rem,5vw,3.5rem)', color: BLACK, margin: '0 0 14px' }}>{title}</h1>
    <div style={{ width: 48, height: 4, background: RED, margin: '0 0 32px' }} />
    {subtitle && <p style={{ fontSize: 15, lineHeight: 1.7, color: 'rgba(0,0,0,0.6)', marginBottom: 32 }}>{subtitle}</p>}
    {children}
  </div>
);
